const Error = () => {
  return (
    <section className="my-[10rem]">
      <div className="w-full flex flex-col justify-center items-center">
        <h1 className="text-primary text-3xl font-[Poppins-Bold]">
          Error 404!
        </h1>
        <h2 className="text-primary text-2xl font-[Poppins-Bold] pt-4">
          Page Not Found
        </h2>
      </div>
    </section>
  );
};
export default Error;
